export const CLOSED_MATCH_STATUSES = [
	'application_closed',
	'candidate_not_available',
	'candidate_not_interested',
	'offer_rejected_by_candidate',
	'rejected_by_customer',
	'rejected_by_recruter',
	//'hired'
] as const;

export const CLOSED_MATCH_STATUSES_FILTER = `(${CLOSED_MATCH_STATUSES.join(',')})`;

export const isClosedMatchStatusValue = (status?: string | null): boolean => {
	if (!status)
		return false;

	return CLOSED_MATCH_STATUSES.includes(status as typeof CLOSED_MATCH_STATUSES[number]);
};